import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent,   FormControlLabel, Radio, withStyles } from '@material-ui/core';


const GreenRadio = withStyles({
  root: {
    color: "rgba(24, 116, 185, 0.27)",
    "&:hover": {
      color: "#1874B9",
    },
    "&$checked": {
      color: "#1874B9",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);


const useStyles = makeStyles({
  card: {
    width: '100%',
    height: 150,
    background: '#fff',
    display: 'flex',
    alignItems: 'center !important',
    cursor: 'pointer',
    borderRadius: 0,
    borderRight: "1px solid rgba(0, 0, 0, 0.10)",
    borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
    boxShadow: "initial",
    transition: "all 0.5s",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0px 8px 14px -5px rgba(0,0,0,0.75)",
    },
  },
  cardBankDam: {
    width: '100%',
    height: 150,
    background: '#fff',
    display: 'flex',
    alignItems: 'center !important',
    borderRadius: 0,
  },
  logoBank: {
    width: '90%',
  },
  CardAdquirents: {
    position: "relative",
    alignItems: "end",
    display: "flex",
    justifyContent: "end",
    zIndex: 2,
    bottom: "50px",
    left: "76%",
  }
});

function CardAcquirerItem(props) {
  const classes = useStyles();
  return (
    <Card
      className={props.staticLogoDam ? classes.cardBankDam : classes.card}
      elevation={0}
    >
      <FormControlLabel
        value={props.acquirer.Sigla}
        className={classes.CardAdquirents}
        control={<GreenRadio className={classes.radioItem} />}
      />
      <CardContent>
        <img
          src={props.src}
          className={classes.logoBank}
          alt="Logo Adquirentes XXX"
        />
      </CardContent>
    </Card>
  );
}

export default CardAcquirerItem
